import posthog from 'posthog-js';
import React, { useEffect } from 'react';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import MessagePage from '@dashboard/components/pages/MessagePage';

export default function Auth0LogoutConfirm(): JsxNode {
  useEffect(() => {
    posthog.reset();
  });

  return (
    <MessagePage
      icon="SUCCESS"
      title="Successfully logged out"
      description="You are now logged out of your account."
      action={
        <ButtonLink href="/" variant="contained" type="submit">
          Login
        </ButtonLink>
      }
    />
  );
}
